import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { PRD4010_R01Filter } from "./Store_PRD4010_R01";
import { PRD4010_R01Dto } from "./Dto_PRD4010_R01";

const baseUrl = `${config.apiUrl}/PRD4010_R01`;

export const getPRD4010_R01List = async (
    option: string,
    filter: Partial<PRD4010_R01Filter>
) => {
    const url = `${baseUrl}/${option}`;
    const params = {
        compCd: filter.compCd || undefined,
        searchDate: filter.searchDate
            ? formatDate(filter.searchDate)
            : undefined,
    };
    return await getData<ResponseDto<PRD4010_R01Dto[]>>(url, { params });
};

export const getLatestPRD4010_R01 = async (compCd?: string) => {
    const url = `${baseUrl}/latest`;
    return await getData<ResponseDto<PRD4010_R01Dto[]>>(url, {
        params: { compCd: compCd || undefined },
    });
};
